<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <div class="attr-chat" ref="attr_container">
            <div class="grid-top-line chats-top-line" ref="attr_top_line" v-if="!attr?.hideCommandPanel">
                <div class="commandPanel-area" ref="commandPanelArea"
                    :style="commandPanelAreaWidth != null ? { flex: '0 1 ' + commandPanelAreaWidth + 'px' } : (!commandPanel.length && !commandPanelOverflow.length ? { flex: '0 0 0', minWidth: '0', overflow: 'hidden' } : {})"
                >
                    <div class="commandPanel-menu" v-if="commandPanel.length && commandPanelMaxVisible !== 0" ref="commandPanelMenu"
                        :style="commandPanelMenuWidth != null ? { flex: '0 0 ' + commandPanelMenuWidth + 'px' } : {}"
                    >
                        <span v-for="(attrM, index) in commandPanel"
                            :key="attrM.html_id"
                            class="cp-item-wrap"
                            v-show="index < commandPanelMaxVisible"
                        >
                            <component
                                :widget_id="widget_id"
                                :is="attrM.component"
                                :attr_id="attrM.id"
                                :initialAttr="attrM"
                            />
                        </span>
                    </div>
                    <div class="widget_menu commandPanel-overflow-btn" v-if="commandPanelOverflow.length">
                        <wj-menu
                            class="commandPanel-overflow-menu"
                            :header="''"
                            :displayMemberPath="'titleAction'"
                            :subItemsPath="'attrs'"
                            :showDropDownButton="false"
                            :openOnHover="true"
                            :isAnimated="false"
                            :itemsSource="commandPanelOverflow"
                            :itemClicked="menuNodeClicked"
                            :formatItem="store.formatMenuItem"
                        >
                            <i class="pi pi-ellipsis-v"></i>
                        </wj-menu>
                    </div>
                </div>
                <div class="grid-chips">
                    <AttrChips :widget_id="widget_id" :attr_id="'chat_CHIPS'" :modelValue="chat_CHIPS" @update:modelValue="onChatChipsUpdate" :mode="'Legacy'"
                        :initialAttr="{
                            attr_type: 'AttrChips',
                            action_afterChange: {'command': 'executeWidgetMethod', 'method': 'select_chat', 'no_del_last_backend_action': true, 'record_sendToBackend_exclude': ['_doc']},
                            binding: 'doc.viewParams.messages.CHIPS',
                            showPlaceholder: true,
                        }"
                    />
                </div>
                <!-- IE 2026 09 28 / ODOO-342342 (заказ Игоря: «"меню" — прижато вправо и форма меню как у ≡ таблицы»): ≡ чата — панель функций MenuPanel (те же пункты actionMenu:
                     Command panel чата; поиск, избранное) у правого края строки; прежний wj-menu — флаг fe.ux.menuPanelEverywhere выключен / мобильный профиль
                     (utils/menuPanelHost.js). Пока у WIDGET-CHATS командная панель пуста — ≡ нет, как и раньше -->
                <div class="widget_menu mr-2" :class="{ 'menu-push-right': menuPanelHost_on() }">
                    <MenuPanel v-if="actionMenu.length && menuPanelHost_on()" :items="actionMenu" align="right" :caret="false" btnClass="widget-menu-btn field-menu-btn"
                        :title="t('Field menu')" titleIcon="pi pi-bars" :subtitle="menuPanelSubtitle()" :openDelay="200" :runsTitle="t('Field')" search :searchPlaceholder="t('Search commands…')"
                        :favKey="menuFavKind()" :favOf="menuFavOf" :epoch="store._favEpoch" :favTitle="t('Favourite command')" help="field" :btnShort="t('Field menu')"
                        @pick="menuPanelPick" @fav="menuFav">
                        <template #trigger><i class="pi pi-bars pi-bold"></i></template>
                    </MenuPanel>
                    <wj-menu id="actionMenuId" :displayMemberPath="'titleAction'" :subItemsPath="'attrs'" :showDropDownButton="false"
                        v-else-if="actionMenu.length"
                        :openOnHover="true" :isAnimated="false" :itemsSource="actionMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
                    >
                        <i class="pi pi-bars pi-bold"></i>
                    </wj-menu>
                </div>
            </div>

            <div class="attr-chat-body">
                <div class="attr-chat-sidebar" ref="sidebarEl" :style="{ width: sidebarWidth + 'px' }">
                    <div
                        v-for="chat in filteredChats"
                        :key="chat.isNew ? '__new__' : (chat.msg.id ?? '__none__')"
                        class="attr-chat-group"
                        :class="{ 'attr-chat-new-btn': chat.isNew, 'attr-chat-group--active': chat.isNew ? selectedChat?.isNew : chatMsg?.id === chat.msg.id, 'attr-chat-group--working': chat.hasStatusWork, 'attr-chat-group--todo': chat.hasStatusTodo }"
                        @click="chat.isNew ? newChat() : selectChat(chat)"
                    >
                        <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                        <div class="attr-chat-group-header">
                            <i v-if="chat.isNew" class="pi pi-plus"></i><!-- webscm 2026 11 02 / ODOO-350849 -->
                            <div class="attr-chat-group-title">{{ chat.isNew ? t('New chat') : chat.msg.title }}</div>
                            <i v-if="chat.newMsg?.doc?.message_md?.trim()" class="pi pi-pen-to-square attr-chat-draft-icon" :title="t('Draft')"></i>
                            <span v-if="chat.unreadCount" class="attr-chat-unread-badge">{{ chat.unreadCount }}</span>
                        </div>
                        <div v-if="!chat.isNew" class="attr-chat-group-meta">{{ chat.messages.length }} · <span class="attr-chat-msg-date" v-html="chat.msg._meta.created_at__html"></span></div>
                    </div>
                    <div v-if="filteredChats.length <= 1" class="attr-chat-side-empty">—</div>
                </div>
                <div class="attr-chat-sidebar-resizer" @mousedown.prevent="startSidebarResize"></div>

                <div class="attr-chat-main">

                    <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                    <div class="chat-top-line">
                        <!-- webscm 2026 11 02 / ODOO-350849 (заказ Андрея: поле вложений непонятно; как скопировать и вставить — объяснение по Alt): подпись, значок и объяснение одни в новом чате и в открытом -->
                        <AttrChips v-if="!isReadOnly && selectedChat?.isNew"
                            :widget_id="widget_id" :attr_id="'chatMsg_CHIPS'" :modelValue="chatMsg_CHIPS" @update:modelValue="onChatMsgChipsUpdate" :mode="'Legacy'"
                            :initialAttr="{
                                attr_type: 'AttrChips',
                                binding: '_doc.chatMsg.doc.CHIPS',
                                placeholder: t('Paste a screenshot or a copied data area…'),
                                showPlaceholder: true,
                                uiHelp: 'chips.input.chat',
                                inputIcon: 'pi-paperclip',
                            }"
                        />
                        <div class="attr-chat-participants" ref="participantsContainer">
                            <button class="attr-chat-participants-toggle" @click.stop="toggleParticipantsPanel">
                                <i class="pi pi-users"></i>
                                <span v-if="participantsPreview" class="attr-chat-participants-names">{{ participantsPreview }}</span>
                            </button>
                            <div v-if="participantsPanelOpen" class="attr-chat-participants-panel" @click.stop>
                                <div class="pcp-label">{{ t('Participants') }}</div>
                                <div v-for="p in chatParticipants" :key="p.user" class="pcp-row">
                                    <input type="checkbox" checked class="pcp-checkbox" @change.prevent="removeParticipant(p.user)" />
                                    <span class="pcp-name">{{ resolveUserName(p.user) }}</span>
                                    <select v-if="p.role !== 'assistant' && p.role !== 'system'" class="pcp-role-select" v-model="p.role" @change="saveParticipants">
                                        <option value="owner">{{ t('owner') }}</option>
                                        <option value="member">{{ t('member') }}</option>
                                        <option value="assigned">{{ t('assigned') }}</option>
                                        <option value="watcher">{{ t('watcher') }}</option>
                                    </select>
                                    <span v-else class="pcp-role-badge">{{ p.role }}</span>
                                </div>
                                <template v-if="availableLLMUsers.length">
                                    <div class="pcp-label pcp-label--mt">{{ t('LLM Agents') }}</div>
                                    <div v-for="u in availableLLMUsers" :key="u.id" class="pcp-row">
                                        <input type="checkbox" class="pcp-checkbox" @change="addParticipant(u.id)" />
                                        <span class="pcp-name">{{ u.title || u.id }}</span>
                                        <span class="pcp-role-badge">{{ t('bot') }}</span>
                                    </div>
                                </template>
                                <div class="pcp-label pcp-label--mt">{{ t('Add user') }}</div>
                                <div class="pcp-add-row">
                                    <AttrLink :widget_id="widget_id" :attr_id="'participants_add_user'"
                                        :initialAttr="{
                                            id: 'participants_add_user',
                                            attr_type: 'AttrLink',
                                            binding: '_doc.participantsNewUserId',
                                            relation_segment: 'USER',
                                            hideTitle: true,
                                            showListButton: true,
                                            showOpenButton: false,
                                            labeled: false,
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="attr-chat-messages" v-if="!selectedChat?.isNew" ref="messagesEl">
                        <template v-for="(msg, msgIdx) in filteredMessages" :key="msg.id">
                            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                            <div v-if="msgIdx === firstUnreadIndex && msgIdx > 0" class="attr-chat-new-msgs-divider">
                                <span>{{ t('New messages') }}</span>
                            </div>
                            <div
                                class="attr-chat-msg"
                                :class="[msg._meta.isLLM ? 'attr-chat-msg--llm' : 'attr-chat-msg--user', { 'attr-chat-msg--working': msg.doc?.status === 'STATUS-work', 'attr-chat-msg--todo': msg.doc?.status === 'STATUS-todo', 'attr-chat-msg--unread': msg._meta.isUnread }]"
                                :data-created-at="msg.created_at"
                            >
                            <div class="attr-chat-msg-header">
                                <span class="attr-chat-msg-author">
                                    <i :class="msg._meta.isLLM ? 'pi pi-microchip-ai' : 'pi pi-user'"></i><!-- IE 2026 09 13 / ODOO-… (иконки) -->
                                    {{ getAssignedFromTitle(msg) }}
                                    <template v-if="getAssignedToTitle(msg) && filteredMessages[msgIdx + 1]?.doc?.author !== getToUser(msg)">
                                        <i class="pi pi-arrow-right attr-chat-msg-author-arrow"></i>{{ getAssignedToTitle(msg) }}
                                    </template>
                                </span>
                                <span class="attr-chat-msg-date" v-html="msg._meta.created_at__html" />
                                <span v-if="msg.doc?.status === 'STATUS-work'" class="attr-chat-msg-elapsed">{{ elapsedText(msg._meta.created_at__ts) }}</span>
                                <button class="attr-chat-open-btn" @click.stop="openRecord(msg)" :title="t('Open record')">
                                    <i class="pi pi-arrow-up-right"></i>
                                </button>
                            </div>
                            <div class="attr-chat-msg-body attrmd-preview" @click="onMsgBodyClick" v-html="activeSearchTerms.length ? searchHighlightHtml(msg._meta.message__html, activeSearchTerms) : msg._meta.message__html"></div>
                            <div class="attr-chat-msg-chips" v-if="msg.doc?.CHIPS?.filter(c => c.meta?.use !== false && c.meta?.hidden !== true).length">
                                <span
                                    v-for="(chip, ci) in msg.doc.CHIPS.filter(c => c.meta?.use !== false && c.meta?.hidden !== true)"
                                    :key="ci"
                                    class="attr-chat-chip"
                                    :class="chip.meta.cssClass"
                                    @click.stop="clickChip(chip, msg, $event)"
                                ><i v-if="chip.meta.pi" :class="['pi', chip.meta.pi]"></i><span v-html="chip.meta.titleHTML || chip.title"></span></span>
                            </div>
                            </div><!-- attr-chat-msg -->
                        </template>
                        <div v-if="!filteredMessages.length" class="attr-chat-empty">{{ t('No messages') }}</div>
                    </div>

                    <template v-if="showCompose">
                    <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                    <div class="chat-msg-top-line" v-if="!isReadOnly && !selectedChat?.isNew">
                        <!-- webscm 2026 11 02 / ODOO-350849: см. поле нового чата выше -->
                        <AttrChips v-if="!isReadOnly"
                            :widget_id="widget_id" :attr_id="'newMsg_CHIPS'" :modelValue="newMsg_CHIPS" @update:modelValue="onNewMsgChipsUpdate" :mode="'Legacy'"
                            :initialAttr="{
                                attr_type: 'AttrChips',
                                binding: '_doc.newMsg.doc.CHIPS',
                                placeholder: t('Paste a screenshot or a copied data area…'),
                                showPlaceholder: true,
                                uiHelp: 'chips.input.chat',
                                inputIcon: 'pi-paperclip',
                            }"
                        />
                    </div>

                    <div class="attr-chat-compose" v-if="newMsg && !isReadOnly">
                        <div class="attr-chat-compose-inner">
                            <textarea
                                v-model="newMsg.doc.message_md"
                                class="attr-chat-textarea"
                                :placeholder="t('Type a message…')"
                                rows="3"
                                @keydown.enter.exact.prevent="sendMessage"
                                @keydown.shift.enter.exact="() => {}"
                            ></textarea>
                            <button
                                v-if="canSend"
                                class="attr-chat-send-btn"
                                @click="sendMessage"
                                :title="t('Send (Enter)')"
                            >
                                <i class="pi pi-arrow-up"></i>
                            </button>
                        </div>
                    </div>
                    </template><!-- showCompose -->
                </div><!-- attr-chat-main -->
            </div><!-- attr-chat-body -->
        </div><!-- attr-chat -->
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import MarkdownIt from 'markdown-it'
import markdownItContainer from 'markdown-it-container'
import markdownItTaskLists from 'markdown-it-task-lists'
import { version } from 'process';
import { menuPanelHostMixin } from '@/utils/menuPanelHost'   // IE 2026 09 28 / ODOO-342342: ≡ чата — MenuPanel (как ≡ таблицы), прижат вправо

export default {
    mixins: [menuPanelHostMixin],   // IE 2026 09 28 / ODOO-342342
    props: ['widget_id', 'attr_id'],
    data: () => ({
        WIDGET: {},
        doc: {},
        binding: '',
        md: null,
        commandPanel: [],
        actionMenu: [],
        commandPanelMaxVisible: Infinity,
        commandPanelAreaWidth: null,
        commandPanelMenuWidth: null,
        ind_commandPanel: 0,
        sidebarWidth: 200,
        resolveIndex: 0,
        now: Date.now(),
        participantsPanelOpen: false,
        
        selectedChat: null,
        newMsgKey: 0,
        showCompose: true,

        newMsg: {
            doc: {
                message_md: '',
                chat: null,
                CHIPS: [],
            },
        },
        chatMsg: {
            doc: {
                message_md: '',
                chat: null,
                CHIPS: [],
            },
        },

    }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET

        const md = new MarkdownIt({ html: true, linkify: true, typographer: true,
            highlight(str, lang) {
                const escaped = md.utils.escapeHtml(str)
                return lang
                    ? `<pre class="language-${lang}"><code class="language-${lang}">${escaped}</code></pre>`
                    : `<pre><code>${escaped}</code></pre>`
            }
        })
        md.use(markdownItTaskLists, { enabled: true, label: true })
        md.use(markdownItContainer, 'alert', {
            validate: p => p.trim().match(/^alert\{type=(\w+)\}$/),
            render(tokens, idx) {
                if (tokens[idx].nesting === 1) {
                    const m = tokens[idx].info.trim().match(/^alert\{type=(\w+)\}$/)
                    return `<div class="attrmd-alert attrmd-alert-${m[1]}">\n`
                }
                return '</div>\n'
            }
        })
        md.block.ruler.before('paragraph', 'record_embed', (state, startLine, endLine, silent) => {
            const pos = state.bMarks[startLine] + state.tShift[startLine]
            const max = state.eMarks[startLine]
            const line = state.src.slice(pos, max).trim()
            const match = line.match(/^\[\[record:(.+)\]\]$/)
            if (!match) return false
            let recordData
            const raw = match[1]
            try {
                recordData = JSON.parse(raw)
            } catch {
                const getField = (key) => raw.match(new RegExp(`"?${key}"?\\s*:\\s*"([^"]*)"`))?.[1] ?? ''
                const id = getField('id')
                if (!id) return false
                recordData = { id, title: getField('title'), segment: getField('segment'), version: getField('version') }
            }
            if (silent) return true
            const token = state.push('record_embed', '', 0)
            token.recordData = recordData
            token.map = [startLine, startLine + 1]
            state.line = startLine + 1
            return true
        })
        this._recordChipMap = {}
        md.renderer.rules.record_embed = (tokens, idx) => {
            const rd = tokens[idx].recordData
            const key = rd.id || String(idx)
            this._recordChipMap[key] = rd
            const title = md.utils.escapeHtml(rd.title || String(rd.id || '') || this.t('(record)'))   // IE 2026 09 23 / ODOO-341407: i18n
            const pi = rd.pi || 'pi-file'
            return `<span class="md-record-chip" data-record-key="${md.utils.escapeHtml(key)}"><span class="md-record-chip-icon pi ${pi} rci-normal"></span><span class="md-record-chip-icon pi pi-cog rci-cog"></span><span class="md-record-chip-text">${title}</span></span>`
        }
        this.md = md

        this.WIDGET.record._doc.participantsNewUserId = ''
        this.newChat()
        this.store.get_itemsSource(this, {}, { relation_segment: 'USER', fetchMode: 'all' })
        this.content_Changed()
    },
    mounted() {
        this.WIDGET.attrsResize = this.WIDGET.attrsResize || []
        this.WIDGET.attrsResize.push(this.attrResize)
        this.$nextTick(() => {
            const container = this.$refs.commandPanelMenu
            const topLine = this.$refs.attr_top_line
            if (container && topLine && !this.commandPanelResizeObserver) {
                this.commandPanelResizeObserver = new ResizeObserver(() => this.updateCommandPanelOverflow())
                this.commandPanelResizeObserver.observe(topLine)
                const chipsEl = topLine.querySelector('.grid-chips')
                if (chipsEl) this.commandPanelResizeObserver.observe(chipsEl)
            }
            this.updateCommandPanelOverflow()
            this.attrResize()
        })
        this._nowInterval = setInterval(() => { this.now = Date.now() }, this.store.setting('fe.polling.chatClockMs', 1000))   // IE 2026 09 05 / ODOO-336330
        this._closeParticipantsPanel = () => { this.participantsPanelOpen = false }
        document.addEventListener('click', this._closeParticipantsPanel)
    },
    beforeUnmount() {
        document.removeEventListener('click', this._closeParticipantsPanel)
        clearTimeout(this._markReadDebounce)
        if (this._scrollMarkReadFn) {
            this.$refs.messagesEl?.removeEventListener('scroll', this._scrollMarkReadFn)
        }
        this.commandPanelResizeObserver?.disconnect()
        if (this._cpRafId) cancelAnimationFrame(this._cpRafId)
        if (this._attrResizeRafId) cancelAnimationFrame(this._attrResizeRafId)
        if (this._nowInterval) clearInterval(this._nowInterval)
        if (this.WIDGET.attrsResize) {
            const idx = this.WIDGET.attrsResize.indexOf(this.attrResize)
            if (idx !== -1) this.WIDGET.attrsResize.splice(idx, 1)
        }
    },
    methods: {
        elapsedText(ts) {
            if (!ts) return ''
            const tzOffsetMs = (this.store.timezoneOffset ?? 0) * 60 * 1000
            const sec = Math.floor((this.now - ts - tzOffsetMs) / 1000)
            if (sec < 0) return ''
            return this.store.formatTimeHTML(sec)
        },
        getAssignedFromTitle(msg) {
            this.resolveIndex // reactivity dependency
            const a = msg._meta?._from_attr
            return a ? (a.valueStr || a.value || this.t('Unknown')) : this.t('Unknown')   // IE 2026 09 23 / ODOO-341407: i18n
        },
        getAssignedToTitle(msg) {
            this.resolveIndex
            const a = msg._meta?._to_attr
            return a ? (a.valueStr || a.value || '') : ''
        },
        getToUser(msg) {
            return msg.doc?.participants?.find(p => p.user !== msg.doc?.author)?.user
                || msg.doc?.assigned_to || ''
        },
        isLLMUser(id) {
            return (id || '').startsWith('LLM')
        },
        resolveUserName(userId) {
            this.resolveIndex // reactivity dependency
            const is = this.store.itemsSource?.['USER']
            if (is?.ids?.[userId]) return is.ids[userId].title || userId
            if (is?.data) {
                const u = is.data.find(u => u.id === userId)
                if (u) return u.title || userId
            }
            return userId
        },
        toggleParticipantsPanel() {
            this.participantsPanelOpen = !this.participantsPanelOpen
        },
        addParticipant(userId) {
            if (!this.chatMsg?.doc) return
            this.chatMsg.doc.participants ||= []
            if (this.chatMsg.doc.participants.some(p => p.user === userId)) return
            const entry = this.isLLMUser(userId)
                ? { user: userId }
                : { user: userId, role: 'member', last_read_at: '' }
            this.chatMsg.doc.participants.push(entry)
            this.saveParticipants()
        },
        removeParticipant(userId) {
            if (!this.chatMsg?.doc?.participants) return
            const idx = this.chatMsg.doc.participants.findIndex(p => p.user === userId)
            if (idx !== -1) this.chatMsg.doc.participants.splice(idx, 1)
            this.saveParticipants()
        },
        saveParticipants() {
            if (!this.chatMsg?.id || this.selectedChat?.isNew) return
            this.store.executeStoreMethod(this.WIDGET.vueObj, {
                command: 'executeWidgetMethod',
                method: 'chat_participants_update',
                record_sendToBackend_exclude: ['_doc'],
                action_name: 'action-front-AttrChat-participants-2026-05-17',
                msg_id: this.chatMsg.id,
                participants: this.chatMsg.doc.participants,
            })
        },
        attrResize() {
            if (this._attrResizeRafId) cancelAnimationFrame(this._attrResizeRafId)
            this._attrResizeRafId = requestAnimationFrame(() => {
                this._attrResizeRafId = null
                const elementForm = document.getElementById(`WIDGET${this.widget_id}`)
                const elementFlex = this.$refs.attr_container
                if (!elementForm || !elementFlex) return
                const widgetRect = elementForm.getBoundingClientRect()
                const flexRect = elementFlex.getBoundingClientRect()
                if (flexRect.height <= 0) return
                let newHeight = Math.floor(widgetRect.bottom - flexRect.top)
                if (newHeight > widgetRect.height) newHeight = 160
                if (newHeight < 160) newHeight = 160
                if (elementFlex.style.height !== `${newHeight}px`) {
                    elementFlex.style.height = `${newHeight}px`
                }
            })
        },
        content_Changed() {
            this.store.widget_attr_set(this)

            // this.attr.binding === _doc.messages
            // const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr)
            // this.doc = doc
            // this.binding = binding

            this.prepare_chats()

            this.set_commandPanel()
        },
        prepare_msg(msg) {
            msg['doc'] = msg['doc'] || {}
            msg['doc'].author = msg['doc'].author || msg.created_by || 'Unknown'
            msg['doc'].chat = msg.doc?.chat || msg.id

            const toUser = this.getToUser(msg)
            const fromAttr = { attr_type: 'AttrLink', relation_segment: 'USER', value: msg.doc.author }
            const toAttr   = { attr_type: 'AttrLink', relation_segment: 'USER', value: toUser }
            this.store.get_valueStr(this, fromAttr, fromAttr)
            this.store.get_valueStr(this, toAttr,   toAttr)

            msg._meta = {
                isLLM: msg.doc.role === 'assistant' || this.isLLMUser(msg['doc'].author),
                isUnread: msg._unread === true,
                created_at__html: msg.created_at ? this.store.formatDateHTML(msg.created_at, true) : '',
                created_at__ts: this.parseDate(msg.created_at)?.getTime() || 0,
                _from_attr: fromAttr,
                _to_attr:   toAttr,
                message__html: this.renderMD(msg.doc?.message_md),
            }
        },
        prepare_chats(opts = {}) {
            const isInitialLoad = !this.selectedChat
            for (const msg of this.chat_messages) {
                this.prepare_msg(msg)
            }

            const prevChats = Array.isArray(this.chats) ? this.chats : []

            // build real chats, preserving per-chat newMsg drafts across calls
            const chats_ = {}
            for (const msg of this.chat_messages) {
                const chatId = msg.doc?.chat ?? 'null'
                if (!chats_[chatId]) {
                    const prev = prevChats.find(c => !c.isNew && (c.msg?.doc?.chat ?? 'null') === chatId)
                    chats_[chatId] = {
                        msg,
                        messages: [msg],
                        newMsg: prev?.newMsg || { doc: { message_md: '', CHIPS: [] } }
                    }
                } else {
                    chats_[chatId].messages.push(msg)
                    if (msg._meta.created_at__ts < chats_[chatId].msg._meta.created_at__ts) {
                        chats_[chatId].msg = msg
                    }
                }
            }

            // sort only real chats (isNew entry has no _meta, must be separate)
            this.chats = Object.values(chats_)
                .map(g => {
                    g.unreadCount = g.messages.filter(m => m._unread === true).length
                    g.hasStatusWork = g.messages.some(m => m.doc?.status === 'STATUS-work')
                    g.hasStatusTodo = g.messages.some(m => m.doc?.status === 'STATUS-todo')
                    g.messages = g.messages.sort((a, b) => {
                        const aHasParent = a.doc?.parent ? 1 : 0
                        const bHasParent = b.doc?.parent ? 1 : 0
                        return (a._meta.created_at__ts - b._meta.created_at__ts) || (aHasParent - bHasParent)
                    })
                    return g
                })
                .sort((a, b) => -(a.msg._meta.created_at__ts - b.msg._meta.created_at__ts))

            // isNew entry: preserve newMsg draft from previous state
            const prevNewMsg = prevChats.find(c => c.isNew)?.newMsg || { doc: { message_md: '', CHIPS: [] } }
            const newChatEntry = {
                msg: prevNewMsg,
                messages: [prevNewMsg],
                newMsg: prevNewMsg,
                isNew: true,
            }
            this.chats.unshift(newChatEntry)
            chats_['new'] = newChatEntry

            // selectedChat
            if (this.selectedChat?.isNew) {
                this.selectedChat = newChatEntry
            } else if (this.chatMsg?.doc?.chat in chats_) {
                this.selectedChat = chats_[this.chatMsg.doc.chat]
            } else {
                this.selectedChat = this.chats.find(c => !c.isNew && c.unreadCount > 0)
                    || this.chats.find(c => !c.isNew)
                    || newChatEntry
            }
            this.ensure_newMsg()
            if (!opts.noScroll) this.scrollToBottom()
            if (isInitialLoad) this.$nextTick(() => this.$nextTick(() => {
                this.scrollSidebarToActive()
                this.selectChat(this.selectedChat)
            }))
        },
        scrollSidebarToActive() {
            const sidebar = this.$refs.sidebarEl
            if (!sidebar || !this.selectedChat) return
            const key = this.selectedChat.isNew ? null : (this.selectedChat.msg?.id ?? this.selectedChat.msg?.doc?.chat)
            const idx = this.selectedChat.isNew
                ? this.chats.findIndex(c => c.isNew)
                : this.chats.findIndex(c => !c.isNew && (c.msg?.id ?? c.msg?.doc?.chat) === key)
            if (idx < 0) return
            const el = sidebar.querySelectorAll('.attr-chat-group')[idx]
            if (!el) return
            el.scrollIntoView({ block: 'nearest' })
        },
        ensure_newMsg() {
            this.WIDGET.record._doc.newMsg = this.newMsg = this.selectedChat.newMsg
            this.WIDGET.record._doc.chatMsg = this.chatMsg = this.selectedChat.msg
        },
        sendMessage() {
            const msg = structuredClone(this.newMsg)

            if (!msg?.doc?.message_md?.trim()) return
            msg.title = msg.doc.message_md.split('\n')[0].slice(0, 100)
            
            if (!msg.id) {
                const authorId = this.store.user?.id || 'Unknown'
                msg['doc'].author = authorId
                msg['doc'].role = 'user'
                msg.created_at = new Date().toISOString()
                msg.id = this.store.hashToUUID('message-' + msg.created_at + authorId + (msg.doc.message_md || ''))
            }

            if (!this.selectedChat?.isNew) {
                msg.doc.chat = this.chatMsg.doc.chat
                msg.doc.chart = this.chatMsg.doc.chart || this.chatMsg.doc.chat
            } else {
                msg.doc.chat = msg.id
                msg.doc.chart = msg.id
                const botUser = this.WIDGET.record.doc?.defaults?.botUser || 'LLM_SUPPORT'
                msg.doc.participants = msg.doc.participants || [
                    { user: msg.doc.author, role: 'owner', last_read_at: '' },
                    { user: botUser, role: 'assistant' },
                ]
                // add to _doc.messages so prepare_chats can find this chat after any re-run
                const _msgs = this.WIDGET.record._doc
                if (_msgs) {
                    if (!Array.isArray(_msgs.messages)) _msgs.messages = []
                    _msgs.messages.unshift(msg)
                }
                // replace isNew entry with a fresh blank one
                const isNewIdx = this.chats.findIndex(c => c.isNew)
                if (isNewIdx !== -1) this.chats.splice(isNewIdx, 1)
                const freshNewMsg = { doc: { message_md: '', CHIPS: [] } }
                this.chats.push({ msg: freshNewMsg, messages: [freshNewMsg], newMsg: freshNewMsg, isNew: true })

                // create real chat and select it
                const chatNewMsg = { doc: { message_md: '', CHIPS: [] } }
                const chat = { msg, messages: [], newMsg: chatNewMsg }
                this.chats.unshift(chat)
                this.selectedChat = chat
            }

            this.store.executeStoreMethod(this.WIDGET.vueObj, {
                command: 'executeWidgetMethod',
                method: 'msg_send',
                record_sendToBackend_exclude: ['_doc'],
                action_name: 'action-front-AttrChat-send-2026-05-05',
                msg: msg,
            })

            this.prepare_msg(msg)
            this.selectedChat.messages.push(msg)

            // clear compose draft for current chat
            this.selectedChat.newMsg = { doc: { message_md: '', CHIPS: [] } }
            this.ensure_newMsg()
            this.showCompose = false
            this.$nextTick(() => { this.showCompose = true })
        },
        set_commandPanel() {
            const commandPanel = []
            const eval_params = { attr: this.attr }
            if (this.attr?.groupMenu?.commandPanel) {
                this.attr.groupMenu.commandPanel.forEach(attrButton => {
                    if (!attrButton.autoGeneratedButton) {
                        const visible_ = this.store.eval_value(this.WIDGET, attrButton['v-if'], eval_params)
                        commandPanel.push({ ...attrButton, visible: visible_ })
                    }
                })
            }
            this.store.prepare_attrs(commandPanel, (this.attr?.html_id || this.attr?.id || 'chat') + (++this.ind_commandPanel))
            this.commandPanel = commandPanel
            this.actionMenu = this.store.actionMenu_from_commandPanel(commandPanel)
            this._cpItemWidths = null
            this.commandPanelMaxVisible = Infinity
            this.commandPanelAreaWidth = null
            this.commandPanelMenuWidth = null
            this.$nextTick(() => {
                const container = this.$refs.commandPanelMenu
                const topLine = this.$refs.attr_top_line
                if (!container || !topLine) return
                if (!this.commandPanelResizeObserver) {
                    this.commandPanelResizeObserver = new ResizeObserver(() => this.updateCommandPanelOverflow())
                }
                this.commandPanelResizeObserver.observe(topLine)
                const chipsEl = topLine.querySelector('.grid-chips')
                if (chipsEl) this.commandPanelResizeObserver.observe(chipsEl)
                this.updateCommandPanelOverflow()
            })
        },
        updateCommandPanelOverflow() {
            if (this._cpRafId) cancelAnimationFrame(this._cpRafId)
            this._cpRafId = requestAnimationFrame(() => {
                this._cpRafId = null
                const cpArea = this.$refs.commandPanelArea
                const topLine = this.$refs.attr_top_line
                if (!cpArea || !topLine) return
                if (topLine.clientWidth <= 10) return
                let itemWidths = this._cpItemWidths
                if (!itemWidths?.length || itemWidths.every(w => w === 0)) {
                    const container = this.$refs.commandPanelMenu
                    itemWidths = container ? Array.from(container.children).map(el => el.offsetWidth) : []
                    if (!itemWidths.length || itemWidths.every(w => w === 0)) return
                    this._cpItemWidths = itemWidths
                }
                const chipsEl = topLine.querySelector('.grid-chips')
                let chipsDesiredWidth = 0
                if (chipsEl) {
                    chipsDesiredWidth = 130
                    const inputContainer = chipsEl.querySelector('.input-container')
                    if (inputContainer) {
                        const children = Array.from(inputContainer.children)
                        const sumW = children.reduce((s, el) => s + el.offsetWidth, 0)
                        chipsDesiredWidth = Math.max(sumW + Math.max(children.length - 1, 0) * 4 + 8, 130)
                    }
                }
                const chipsCurrentWidth = chipsEl?.clientWidth ?? 0
                const available = Math.max(cpArea.clientWidth + chipsCurrentWidth - chipsDesiredWidth, 0)
                let total = 0
                let maxVisible = itemWidths.length
                for (let i = 0; i < itemWidths.length; i++) {
                    total += itemWidths[i]
                    if (total > available) { maxVisible = i; break }
                }
                let overflowBtnWidth = 0
                if (maxVisible < itemWidths.length) {
                    const overflowBtnEl = cpArea.querySelector('.commandPanel-overflow-btn')
                    overflowBtnWidth = overflowBtnEl ? overflowBtnEl.offsetWidth : 28
                    const availableForItems = Math.max(available - overflowBtnWidth, 0)
                    total = 0
                    maxVisible = itemWidths.length
                    for (let i = 0; i < itemWidths.length; i++) {
                        total += itemWidths[i]
                        if (total > availableForItems) { maxVisible = i; break }
                    }
                }
                if (this.commandPanelMaxVisible !== maxVisible) this.commandPanelMaxVisible = maxVisible
                let visibleItemsWidth = itemWidths.slice(0, maxVisible).reduce((a, b) => a + b, 0)
                let visibleWidth = visibleItemsWidth + overflowBtnWidth
                if (!this.commandPanelOverflow.length) { visibleItemsWidth += 10; visibleWidth += 10 }
                if (this.commandPanelMenuWidth !== visibleItemsWidth) this.commandPanelMenuWidth = visibleItemsWidth
                if (this.commandPanelAreaWidth !== visibleWidth) this.commandPanelAreaWidth = visibleWidth
            })
        },
        menuNodeClicked(menu) {
            this.menuAction(menu.itemsSource[menu.selectedIndex])   // IE 2026 09 28 / ODOO-342342: выбор пункта wj-menu и MenuPanel (menuPanelPick) — одно действие
        },
        menuAction(action) {   // IE 2026 09 28 / ODOO-342342: прежнее тело menuNodeClicked
            this.store.executeStoreMethod(this.WIDGET.vueObj, action)
        },
        onChatChipsUpdate(chips) {
            this.WIDGET.record.doc.viewParams ||= {}
            this.WIDGET.record.doc.viewParams.messages ||= {}
            this.WIDGET.record.doc.viewParams.messages.CHIPS = chips
        },
        onNewMsgChipsUpdate(chips) {
            this.newMsg.doc.CHIPS = chips
        },
        onChatMsgChipsUpdate(chips) {
            if (!this.chatMsg?.doc) return
            this.chatMsg.doc.CHIPS = chips
        },
        onSelectedChatMsgChipsUpdate(chips) {
            if (!this.chatMsg?.doc) return
            this.chatMsg.doc.CHIPS = chips
        },
        renderMD(text) {
            return this.md ? this.md.render(text || '') : (text || '')
        },
        parseDate(val) {
            if (!val) return null
            const d = new Date(val)
            return isNaN(d.getTime()) ? null : d
        },
        startSidebarResize(e) {
            const startX = e.clientX
            const startWidth = this.sidebarWidth
            const onMove = (e) => {
                this.sidebarWidth = Math.max(120, Math.min(600, startWidth + e.clientX - startX))
            }
            const onUp = () => {
                document.removeEventListener('mousemove', onMove)
                document.removeEventListener('mouseup', onUp)
            }
            document.addEventListener('mousemove', onMove)
            document.addEventListener('mouseup', onUp)
        },
        newChat() {
            const authorId = this.store.user?.id || 'Unknown'
            const botUser = this.WIDGET.record.doc?.defaults?.botUser || 'LLM_SUPPORT'
            const newChatEntry = Array.isArray(this.chats) ? this.chats.find(c => c.isNew) : null
            if (!newChatEntry) return
            newChatEntry.newMsg.doc.author = authorId
            newChatEntry.newMsg.doc.participants = [
                { user: authorId, role: 'owner', last_read_at: '' },
                { user: botUser, role: 'assistant' },
            ]
            this.selectedChat = newChatEntry
            this.ensure_newMsg()
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const el = this.$refs.messagesEl
                if (el) el.scrollTop = el.scrollHeight
            })
        },
        selectChat(chat) {
            const WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
            if (WRow && WRow.parentAction?.type === 'widget-row-chip') this.store.widget_close(WRow.id)
            this.selectedChat = chat
            this.ensure_newMsg()
            if (!chat.isNew) {
                this.scrollToBottom()
                const chatId = chat.msg.doc?.chat || chat.msg.id
                if (chat.unreadCount > 0) this.markRead(chatId)
                this.$nextTick(() => this.setupScrollMarkRead())
            }
        },
        markRead(chatId, upTo) {
            if (!chatId) return
            const payload = {
                command: 'executeWidgetMethod',
                method: 'mark_read',
                record_sendToBackend_exclude: ['_doc'],
                chat: chatId,
            }
            if (upTo) payload.up_to = upTo
            if (!this.store.readonly_on()) this.store.executeStoreMethod(this.WIDGET.vueObj, payload)   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — отметку прочитанного на бэк не шлём (mark_read запрещён); локальное «прочитано» ниже остаётся
            // optimistic: clear local unread state
            const chat = this.chats.find(c => (c.msg.doc?.chat || c.msg.id) === chatId)
            if (chat) {
                for (const msg of chat.messages) {
                    if (msg._unread) {
                        msg._unread = false
                        if (msg._meta) msg._meta.isUnread = false
                    }
                }
                chat.unreadCount = 0
            }
        },
        setupScrollMarkRead() {
            const messagesEl = this.$refs.messagesEl
            if (!messagesEl) return
            if (this._scrollMarkReadFn) {
                messagesEl.removeEventListener('scroll', this._scrollMarkReadFn)
            }
            this._scrollMarkReadFn = () => {
                clearTimeout(this._markReadDebounce)
                this._markReadDebounce = setTimeout(() => {
                    if (!this.selectedChat) return
                    const elMsgs = messagesEl.querySelectorAll('[data-created-at]')
                    let lastCreatedAt = null
                    const bottom = messagesEl.scrollTop + messagesEl.clientHeight
                    for (const el of elMsgs) {
                        if (el.offsetTop + el.offsetHeight <= bottom + 40) {
                            lastCreatedAt = el.dataset.createdAt || null
                        }
                    }
                    if (!lastCreatedAt) return
                    if (!this.selectedChat?.unreadCount) return
                    const chatId = this.chatMsg.doc?.chat || this.chatMsg.id
                    this.markRead(chatId, lastCreatedAt)
                }, 1500)
            }
            messagesEl.addEventListener('scroll', this._scrollMarkReadFn)
        },
        applyUpdateChatMsg(updatedMsg) {
            const messages = this.WIDGET.record._doc?.messages
            if (!Array.isArray(messages)) return
            const idx = messages.findIndex(m => m.id === updatedMsg.id)
            if (idx !== -1) {
                messages[idx] = updatedMsg
            } else {
                messages.push(updatedMsg)
            }
            this.prepare_chats({ noScroll: true })
            if (this._pendingChipOpen?.msgId === updatedMsg.id) {
                const { chipIdxInArray, cogXY } = this._pendingChipOpen
                this._pendingChipOpen = null
                const chip = (updatedMsg.doc?.CHIPS || [])[chipIdxInArray]
                if (chip) this._doOpenChipRow(chip, updatedMsg, cogXY)
            }
        },
        searchHighlightHtml(html, terms) {
            let result = html
            for (const term of terms) {
                const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                result = result.replace(new RegExp(`(${escaped})(?![^<]*>)`, 'gi'), '<mark class="chat-search-highlight">$1</mark>')
            }
            return result
        },
        onMsgBodyClick(e) {
            const chip = e.target.closest('.md-record-chip')
            if (!chip) return
            e.stopPropagation()
            const rd = this._recordChipMap[chip.dataset.recordKey]
            if (!rd?.id) return
            if (e.target.closest('.md-record-chip-icon')) {
                const chipEl = e.target.closest('.md-record-chip-icon')
                const widgetEl = document.getElementById('WIDGET' + this.WIDGET.id)
                let selectedCog
                if (chipEl && widgetEl) {
                    const cr = chipEl.getBoundingClientRect()
                    const wr = widgetEl.getBoundingClientRect()
                    selectedCog = { x: cr.left - wr.left + cr.width / 2, y: cr.top - wr.top + cr.height / 2 }
                }
                this.store.executeStoreMethod(this.WIDGET.vueObj, {
                    command: 'widget_open',
                    widget: 'widget-row',
                    type: 'widget-row-record-embed',
                    open_in_children_widget: true,
                    item: {
                        id: rd.id, segment: rd.segment, version: rd.version || '',
                        title: rd.title || rd.id,
                        _meta: { type: 'widget-row-record-embed' },
                        _record: rd,
                    },
                    widgetRow_params: { top_pct: 0.6, left_pct: 0.2, width_pct: 0.8, height_pct: 0.8 },
                    selectedCog,
                })
            } else {
                const vueObj = this.WIDGET?.vueObj
                if (!vueObj) return
                this.store.executeStoreMethod(vueObj, {
                    command: 'widget_open',
                    widget: 'widget-record',
                    item: {
                        id: rd.id,
                        segment: rd.segment,
                        version: rd.version,
                        title: rd.title,
                    },
                })
            }
        },
        openRecord(msg) {
            this.store.widget_open({
                record: {
                    id: msg.id,
                    segment: msg.segment || this.attr.relation_segment || 'LLM-INSIGHT',
                    version: msg.version || '',
                },
                widget: 'widget-record',
                parentAction: {
                    action_name: 'action-front-AttrChat-open-2026-05-05',
                    method: 'AttrChat.openRecord',
                },
            }, this)
        },
        clickChip(chip, msg, event) {
            if (chip.meta?.action) {
                this.store.executeStoreMethod(this.WIDGET.vueObj, chip.meta.action)
                return
            }
            const cogXY = this._chipCogXY(event)
            if (!chip.doc) {
                this._pendingChipOpen = {
                    msgId: msg.id,
                    chipIdxInArray: (msg.doc?.CHIPS || []).indexOf(chip),
                    cogXY,
                }
                this.store.executeStoreMethod(this.WIDGET.vueObj, {
                    command: 'executeWidgetMethod',
                    method: 'get_msg',
                    record_sendToBackend_exclude: ['_doc'],
                    msg_id: msg.id,
                })
                return
            }
            this._doOpenChipRow(chip, msg, cogXY)
        },
        _chipCogXY(event) {
            const chipEl = event?.currentTarget
            const widgetEl = document.getElementById('WIDGET' + this.WIDGET.id)
            if (!chipEl || !widgetEl) return undefined
            const cr = chipEl.getBoundingClientRect()
            const wr = widgetEl.getBoundingClientRect()
            return { x: cr.left - wr.left + cr.width / 2, y: cr.top - wr.top + cr.height / 2 }
        },
        _doOpenChipRow(chip, msg, cogXY) {
            const messages = this.WIDGET.record._doc?.messages || []
            const msgIdx = messages.findIndex(m => m.id === msg.id)
            if (msgIdx < 0) return
            const binding = `_doc.messages[${msgIdx}].doc.CHIPS`
            const visibleChips = (msg.doc?.CHIPS || []).filter(c => !c.hidden)
            const chipIdx = visibleChips.findIndex(c => c === chip)
            if (chipIdx < 0) return
            this.store.executeStoreMethod(this.WIDGET.vueObj, {
                command: 'widget_open',
                widget: 'widget-row',
                type: 'widget-row-chip',
                source_attr_type: chip.segment || chip._raw?.segment,
                binding,
                source: {
                    title: chip.title,
                    index: chipIdx,
                },
                get_Parent: true,
                open_in_children_widget: true,
                selectedCog: cogXY,
            })
        },
    },
    watch: {
        'store.itemsSource_change_index'(newVal, oldVal) {
            const changedSet = this.store.get_itemsSource_changedSet(newVal, oldVal)
            if (changedSet !== null && !changedSet.has('USER')) return
            for (const msg of this.chat_messages) {
                if (msg._meta?._from_attr) this.store.get_valueStr(this, msg._meta._from_attr, msg._meta._from_attr)
                if (msg._meta?._to_attr)   this.store.get_valueStr(this, msg._meta._to_attr,   msg._meta._to_attr)
            }
            this.resolveIndex++
        },
        'WIDGET.record._doc.participantsNewUserId'(newVal) {
            if (!newVal) return
            this.addParticipant(newVal)
            this.WIDGET.record._doc.participantsNewUserId = ''
        },
    },
    computed: {
        isReadOnly() {
            return this.WIDGET?.isReadOnly || this.attr?.isReadOnly || this.attr?.fieldMapping?.use || false
        },
        chat_messages() {
            return this.WIDGET.record._doc?.messages || []
        },
        chat_CHIPS() {
            return this.WIDGET.record.doc?.viewParams?.messages?.CHIPS || []
        },
        newMsg_CHIPS() {
            return this.newMsg.doc?.CHIPS || []
        },
        chatMsg_CHIPS() {
            return this.newMsg.doc?.CHIPS || []
        },
        selectedChatMsg_CHIPS() {
            return this.chatMsg?.doc?.CHIPS || []
        },
        selectedChatMsgChipsBinding() {
            if (!this.chatMsg) return ''
            const messages = this.WIDGET.record._doc?.messages || []
            const idx = messages.findIndex(m => m.id === this.chatMsg.id)
            return idx >= 0 ? `_doc.messages[${idx}].doc.CHIPS` : ''
        },
        activeSearchTerms() {
            return (this.chat_CHIPS)
                .filter(c => c.meta?.use !== false && c.segment === 'CHIP-Search')
                .map(c => c.title)
        },
        filteredChats() {
            if (!this.activeSearchTerms.length) return this.chats
            const terms = this.activeSearchTerms.map(t => t.toLowerCase())
            return this.chats.filter(chat => {
                if (chat.isNew) return true
                return chat.messages.some(msg => {
                    const text = (msg.doc?.message_md || '').toLowerCase()
                    return terms.some(term => text.includes(term))
                })
            })
        },
        filteredMessages() {
            if (!this.selectedChat) return []
            if (!this.activeSearchTerms.length) return this.selectedChat.messages
            const terms = this.activeSearchTerms.map(t => t.toLowerCase())
            return this.selectedChat.messages.filter(msg => {
                const text = (msg.doc?.message_md || '').toLowerCase()
                return terms.some(term => text.includes(term))
            })
        },
        commandPanelOverflow() {
            if (this.commandPanelMaxVisible >= this.commandPanel.length) return []
            return this.commandPanel
                .slice(this.commandPanelMaxVisible)
                .filter(item => item.attr_type !== 'AttrSeparator' && item.visible !== false)
        },
        canSend() {
            return !!this.newMsg?.doc?.message_md?.trim()
        },
        chatParticipants() {
            return this.chatMsg?.doc?.participants || []
        },
        participantsPreview() {
            const ps = this.chatParticipants
            if (!ps.length) return ''
            const names = ps.slice(0, 2).map(p => this.resolveUserName(p.user))
            const rest = ps.length - 2
            return rest > 0 ? `${names.join(', ')} +${rest}` : names.join(', ')
        },
        availableLLMUsers() {
            const inChat = new Set(this.chatParticipants.map(p => p.user))
            const is = this.store.itemsSource?.['USER']
            return (is?.data || []).filter(u => this.isLLMUser(u.id) && !inChat.has(u.id))
        },
        firstUnreadIndex() {
            return this.filteredMessages.findIndex(m => m._meta?.isUnread)
        },
        isAdmin() {
            return !!(this.store.user?.is_admin || this.store.user?.access?.admin)
        },
    },
}
</script>

<style scoped>
.attr-chat {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--surface-border);
    border-radius: 6px;
    overflow: hidden;
    box-sizing: border-box;
}

.chats-top-line {
    flex-shrink: 0;
    z-index: 10;
    background: white;
    border-bottom: 1px solid var(--surface-border);
}

.attr-chat-body {
    flex: 1;
    display: flex;
    min-height: 0;
    overflow: hidden;
}

.attr-chat-sidebar-resizer {
    width: 4px;
    flex-shrink: 0;
    cursor: col-resize;
    background: var(--surface-border);
    transition: background 0.15s;
}
.attr-chat-sidebar-resizer:hover,
.attr-chat-sidebar-resizer:active {
    background: var(--primary-color);
}

.attr-chat-sidebar {
    flex-shrink: 0;
    border-right: 1px solid var(--surface-border);
    overflow-y: auto;
    background: var(--surface-ground);
}

.attr-chat-group {
    padding: 0.6rem 0.75rem;
    cursor: pointer;
    border-bottom: 1px solid var(--surface-border);
    border-left: 3px solid transparent;
}
.attr-chat-group:hover {
    background: var(--surface-hover);
}
.attr-chat-group--active {
    background: var(--blue-50, #EFF6FF);
    border-left-color: var(--primary-color);
}
/* webscm 2026 11 02 / ODOO-350849 (заказ Андрея: кнопка новой беседы не читается, цвет из палитры): «New chat» — кнопка цветами верхней полосы стола. Пара --cs-topbar-bg / -fg читается
   во всех гаммах (текст на --cs-accent — нет: 1c 2,6:1, 3k 2,8:1, 5f 3,1:1); рамка --cs-topbar-accent держит форму там, где полоса светлая (5f, 6m); classic полосу не красит — primary */
.attr-chat-new-btn {
    margin: 0.4rem 0.5rem;
    padding: 0.4rem 0.6rem;
    border: 1px solid var(--cs-topbar-accent, var(--primary-color));
    border-radius: 6px;
    background: var(--cs-topbar-bg, var(--primary-color));
    color: var(--cs-topbar-fg, var(--primary-color-text));
}
.attr-chat-new-btn:hover {
    background: var(--cs-topbar-bg, var(--primary-color));
    opacity: 0.85;
}
.attr-chat-new-btn.attr-chat-group--active {
    outline: 2px solid var(--cs-topbar-accent, var(--primary-color));
    outline-offset: 1px;
}
.attr-chat-new-btn .pi {
    font-size: 0.72rem;
}

.attr-chat-group-header {
    display: flex;
    align-items: center;
    gap: 0.3rem;
}

.attr-chat-group-title {
    font-weight: 600;
    font-size: 0.82rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
}

.attr-chat-draft-icon {
    flex-shrink: 0;
    font-size: 0.65rem;
    color: var(--text-color-secondary);
    opacity: 0.7;
}

.attr-chat-unread-badge {
    flex-shrink: 0;
    min-width: 1.2rem;
    height: 1.2rem;
    padding: 0 0.3rem;
    border-radius: 999px;
    background: var(--primary-color);
    color: #fff;
    font-size: 0.65rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}
.attr-chat-group-meta {
    font-size: 0.72rem;
    color: var(--text-color-secondary);
    margin-top: 2px;
}

.attr-chat-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.attr-chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.attr-chat-msg {
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
}
.attr-chat-msg--llm {
    background: var(--surface-ground);
    border: 1px solid var(--surface-border);
}
.attr-chat-msg--user {
    background: var(--blue-50, #EFF6FF);
    border: 1px solid var(--blue-100, #DBEAFE);
    align-self: flex-end;
    width: 92%;
}

.attr-chat-msg--working {
    background: var(--yellow-50, #FEFCE8) !important;
    border-color: var(--yellow-200, #FEF08A) !important;
    animation: chat-working-pulse 2s ease-in-out infinite;
}

@keyframes chat-working-pulse {
    0%, 100% { background-color: var(--yellow-50, #FEFCE8); }
    50% { background-color: var(--yellow-100, #FEF9C3); }
}

.attr-chat-group--working {
    background: var(--yellow-50, #FEFCE8) !important;
    border-left-color: var(--yellow-400, #FACC15) !important;
    animation: chat-working-pulse 2s ease-in-out infinite;
}

.attr-chat-msg--todo {
    background: var(--purple-50, #FAF5FF) !important;
    border-color: var(--purple-200, #E9D5FF) !important;
}

.attr-chat-group--todo {
    background: var(--purple-50, #FAF5FF) !important;
    border-left-color: var(--purple-400, #C084FC) !important;
}

.attr-chat-msg-header {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.78rem;
    color: var(--text-color-secondary);
    margin-bottom: 0.25rem;
}
.attr-chat-msg-author {
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.2rem;
}
.attr-chat-msg-author-arrow {
    font-size: 0.65rem;
    color: var(--text-color-secondary);
}
.attr-chat-msg-date {
    flex: 1;
}

.attr-chat-msg--unread {
    border-left: 3px solid var(--primary-color) !important;
}

.attr-chat-new-msgs-divider {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--primary-color);
    font-size: 0.72rem;
    font-weight: 600;
}
.attr-chat-new-msgs-divider::before,
.attr-chat-new-msgs-divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--primary-color);
    opacity: 0.35;
}


.attr-chat-msg-elapsed {
    font-size: 0.72rem;
    font-weight: 600;
    color: var(--yellow-700, #A16207);
    background: var(--yellow-100, #FEF9C3);
    border-radius: 999px;
    padding: 0 0.4rem;
    white-space: nowrap;
}

.attr-chat-open-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: var(--text-color-secondary);
    padding: 1px 3px;
    border-radius: 4px;
    font-size: 0.8rem;
    line-height: 1;
}
.attr-chat-open-btn:hover {
    color: var(--primary-color);
    background: var(--surface-hover);
}

.attr-chat-msg-body {
    font-size: 0.88rem;
}
.attr-chat-msg-body.attrmd-preview {
    padding: 0;
}
.attr-chat-msg-body :deep(.md-record-chip-icon.rci-cog) { display: none; }
.attr-chat-msg-body :deep(.md-record-chip:hover .md-record-chip-icon.rci-normal) { display: none; }
.attr-chat-msg-body :deep(.md-record-chip:hover .md-record-chip-icon.rci-cog) { display: inline; }

.chat-top-line {
    flex-shrink: 0;
    border-top: 1px solid var(--surface-border);
    padding: 0.2rem 0.5rem;
    background: var(--surface-ground);
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex-wrap: wrap;
}
.chat-top-line :deep(.chips-container) {
    flex: 1;
    min-width: 0;
}
.chat-top-line :deep(.chips-input) {
    background: var(--surface-ground);
}
/* webscm 2026 11 02 / ODOO-350849: подпись поля вложений — инструкция, а не декор: цвет базового #aaa AttrChips на этом фоне нечитаем; в узком виджете — одна строка с многоточием, целиком текст в объяснении по Alt */
.chat-top-line :deep(.chips-placeholder-text),
.chat-msg-top-line :deep(.chips-placeholder-text) {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: var(--text-color-secondary);
}

.chat-msg-top-line {
    flex-shrink: 0;
    border-top: 1px solid var(--surface-border);
    padding: 0.2rem 0.5rem;
    background: var(--surface-ground);
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex-wrap: wrap;
}
.chat-msg-top-line :deep(.chips-container) {
    flex: 1;
    min-width: 0;
}
.chat-msg-top-line :deep(.chips-input) {
    background: var(--surface-ground);
}

/* Participants panel */
.attr-chat-participants {
    position: relative;
    margin-left: auto;
    flex-shrink: 0;
}

.attr-chat-participants-toggle {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    background: none;
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 0.15rem 0.4rem;
    cursor: pointer;
    font-size: 0.75rem;
    color: var(--text-color-secondary);
}
.attr-chat-participants-toggle:hover {
    background: var(--surface-hover);
    border-color: var(--surface-border);
    color: var(--text-color);
}
.attr-chat-participants-names {
    max-width: 14rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.attr-chat-participants-panel {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    z-index: 100;
    background: var(--surface-card, #fff);
    border: 1px solid var(--surface-border);
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.12);
    min-width: 240px;
    max-width: 320px;
    padding: 0.5rem 0;
}

.pcp-label {
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--text-color-secondary);
    padding: 0 0.75rem 0.2rem;
}
.pcp-label--mt {
    margin-top: 0.4rem;
    padding-top: 0.4rem;
    border-top: 1px solid var(--surface-border);
}

.pcp-row {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.2rem 0.75rem;
}
.pcp-row:hover {
    background: var(--surface-hover);
}

.pcp-checkbox {
    flex-shrink: 0;
    cursor: pointer;
}

.pcp-name {
    flex: 1;
    font-size: 0.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pcp-role-select {
    font-size: 0.72rem;
    border: 1px solid var(--surface-border);
    border-radius: 3px;
    background: var(--surface-ground);
    color: var(--text-color-secondary);
    padding: 0.05rem 0.2rem;
    cursor: pointer;
}

.pcp-role-badge {
    font-size: 0.68rem;
    color: var(--text-color-secondary);
    background: var(--surface-200, #e2e8f0);
    border-radius: 999px;
    padding: 0 0.35rem;
    white-space: nowrap;
}

.pcp-add-row {
    padding: 0.3rem 0.75rem 0.2rem;
}
.pcp-add-row :deep(.wj-control) {
    font-size: 0.8rem;
}
.pcp-add-row :deep(input.wj-form-control) {
    font-size: 0.8rem;
    padding: 0.15rem 0.4rem;
    height: auto;
    min-height: unset;
    font-family: inherit;
}

.attr-chat-compose {
    border-top: 1px solid var(--surface-border);
    padding: 0.6rem 0.75rem;
    background: var(--surface-card);
}

.attr-chat-compose-inner {
    position: relative;
}

.attr-chat-textarea {
    width: 100%;
    resize: vertical;
    border: 1px solid var(--surface-border);
    border-radius: 6px;
    padding: 0.4rem 2.2rem 0.4rem 0.6rem;
    font-family: inherit;
    font-size: 0.88rem;
    line-height: 1.5;
    box-sizing: border-box;
    background: var(--surface-0, #fff);
    color: var(--text-color);
}
.attr-chat-textarea:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 1px var(--primary-color);
}

.attr-chat-send-btn {
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    border: none;
    background: var(--primary-color);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
    transition: opacity 0.15s;
}
.attr-chat-send-btn:hover {
    opacity: 0.85;
}

.attr-chat-empty,
.attr-chat-side-empty {
    color: var(--text-color-secondary);
    font-size: 0.82rem;
    padding: 1rem;
    text-align: center;
}

.attr-chat-msg-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    margin-top: 0.35rem;
}
.attr-chat-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    font-size: 0.72rem;
    padding: 0.1rem 0.45rem;
    border-radius: 999px;
    background: var(--surface-200, #e2e8f0);
    color: var(--text-color-secondary);
    white-space: nowrap;
    cursor: pointer;
}
.attr-chat-chip:hover {
    background: var(--surface-300, #cbd5e1);
    color: var(--text-color);
}
.attr-chat-chip .pi {
    font-size: 0.68rem;
}

.chat-search-highlight {
    background: var(--yellow-200, #FEF08A);
    color: var(--text-color);
    border-radius: 2px;
    padding: 0 1px;
}
</style>
